import { render, staticRenderFns } from "./NotificationBar.vue?vue&type=template&id=20dbc528&"
import script from "./NotificationBar.vue?vue&type=script&lang=js&"
export * from "./NotificationBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/marcosalazar/Documents/HM/Timelapse/timelapse-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20dbc528')) {
      api.createRecord('20dbc528', component.options)
    } else {
      api.reload('20dbc528', component.options)
    }
    module.hot.accept("./NotificationBar.vue?vue&type=template&id=20dbc528&", function () {
      api.rerender('20dbc528', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NotificationBar.vue"
export default component.exports